import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-trip-describe',
  templateUrl: './trip-describe.component.html',
  styleUrls: ['./trip-describe.component.scss']
})
export class TripDescribeComponent extends NgbActiveModal implements OnInit {

  constructor(
    public activeModal: NgbActiveModal
  ) {
    super();
  }

  ngOnInit() {
  }

}
